<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/alltransaction/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            :needBeforeSubmit="needBefore"
            @success="onSuccess"
            @beforeSubmit="beforeSubmit"
            :show="false"
            ref="commonTop"
        >
            <el-form-item label="代理商ID">
                <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="操作时间" prop="time">
                <el-date-picker
                    v-model="formModel.time"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="请选择"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table
            :data="tableData"
            ref="commonTable"
            @handleChange="getPage"
            :isShow="false"
        >
            <el-table-column
                prop="parentId"
                label="上级代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="id"
                label="代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="realName"
                label="代理商姓名"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="phoneNumber"
                label="代理商手机号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="transaction"
                label="总交易量"
                :formatter="formatterTableNumber"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import StatisticsService from "service/StatisticsService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "teamtransaction",
        components: {
            CommonTopForm,
            CommonTable,
        },
        data() {
            return {
                formModel: {
                    userId: "",
                    time: "",
                },
                needBefore: true,
                tableData: [],
                submitService: StatisticsService.TeamMonthTransactionList,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                const params = {
                    userId: this.formModel.userId,
                    myDate: this.formModel.time,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    time: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            beforeSubmit() {
                if (!this.formModel.time) {
                    this.showError('请选择操作时间 ')
                    return
                }
                this.needBefore = false;
                this.$nextTick(() => {
                    this.$refs.commonTop.submit();
                })
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                    this.needBefore = true;
                });
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Statistics/AllTransaction.vue